import { IAbstractRecord } from '@models';
import { IListingData } from '@models/listing';

export function mapToCancellationAmendmentDetails(data: any): IListingData {
  const covers =
    data?.Production?.queries?.getCancellationAmendmentDetails || [];

  const pagedItems: IAbstractRecord = {};

  covers.forEach((cover: any, index: number) => {
    const baseProperties =
      cover?.amendmentInsuredPOMedical_InsuredPricingOptionMedicalID?.views
        ?.Production_all?.properties;
    const amendmentCoverSumInsured =
      cover?.amendmentInsuredPOMedical_AmendmentCoverSumInsured;
    const amendmentCoverNetPremiumValue =
      cover?.amendmentInsuredPOMedical_AmendmentCoverNetPremiumValue;
    const amendmentCoverCost =
      cover?.amendmentInsuredPOMedical_AmendmentCoverCost;
    const amendmentCoverCharges =
      cover?.amendmentInsuredPOMedical_AmendmentCoverCharges;
    const amendmentCoverTPAFees =
      cover?.amendmentInsuredPOMedical_AmendmentCoverTPAFees;
    const amendmentCoverGrossPremium =
      cover?.amendmentInsuredPOMedical_AmendmentCoverGrossPremium;
    const amendmentCoverTotalPremium =
      cover?.amendmentInsuredPOMedical_AmendmentCoverTotalPremium;

    pagedItems[index] = {
      id: cover?.amendmentInsuredPOMedical_InsuredPricingOptionMedicalID?.id,

      InsuredName:
        baseProperties?.PolicyPersonID?.views?.Production_all?.properties
          ?.FullName || '',
      Relation:
        baseProperties?.PolicyPersonID?.views?.Production_all?.properties
          ?.Relation || '',
      SumInsured: baseProperties?.CoverSumInsured || '',
      NetPremium: baseProperties?.CoverNetPremiumValue || '',
      Charges: baseProperties?.CoverCharges || '',
      TPAFees: baseProperties?.CoverTPAFees || '',
      GrossPremium: baseProperties?.CoverGrossPremium || '',
      TotalPremium: baseProperties?.CoverTotalPremium || '',
      SumInsuredVariance: amendmentCoverSumInsured || '',
      NetPremiumVariance: amendmentCoverNetPremiumValue || '',
      PolicyCostVariance: amendmentCoverCost || '',
      ChargesVariance: amendmentCoverCharges || '',
      TPAFeesVariance: amendmentCoverTPAFees || '',
      GrossPremiumVariance: amendmentCoverGrossPremium || '',
      TotalPremiumVariance: amendmentCoverTotalPremium || '',
    };
  });

  return {
    pagedItems,
    totalCount: covers.length,
    pageNumber: 1,
    pageSize: 10,
  };
}
